export default "__VITE_ASSET__DGTMM7iw__"